import { Button } from '@boozallen-uip/uswds-react-core';
import React, { useContext } from 'react';
import { useNavigate } from "react-router-dom";
import AccessStatus from '../../../components/AccessStatus.component';
import { UserContext } from '../../UserContext';
import { ACCESS_DENIED, ACCESS_NO_LOGIN, ACCESS_WAITING, ACCESS_LEVEL_ADMIN, PRODUCT_SUBMIT_URL, ENTITY_APPROVAL_URL, VENDOR_OVERVIEW_URL, ORGANIZATION_CREATE_URL, ACR_EDITOR_BASE_URL } from '../../../utlities/core.constants';

const IMAGE_MAN_WORKING = '/section-images/man-working.jpeg';
const IMAGE_CREATE_ORGANIZATION = '/section-images/hand-stack.jpeg';
const IMAGE_TAKING_NOTES = '/section-images/taking-notes.jpeg';
const IMAGE_TALL_BUILDINGS = '/section-images/tall-buildings.jpeg';
const IMAGE_STICKY_NOTES = '/section-images/sticky-notes.jpeg';

export default function DashboardList() {
  const { checkEntityAccessLevel, userEntity, isLoggedIn, hasPendingRequestAccess, isAgencyUser, isVendorUser, isSuperUser, isImpersonating } = useContext(UserContext);
  const navigate = useNavigate();

  if (!isLoggedIn()) {
    return (
      <AccessStatus access={ACCESS_NO_LOGIN} />
    )
  }

  if (!checkEntityAccessLevel()) {
    return (
      <AccessStatus access={ACCESS_DENIED} />
    )
  }

  if (hasPendingRequestAccess) {
    return (
      <AccessStatus access={ACCESS_WAITING} />
    )
  }


    return (
    <>
      {isSuperUser && (
        <>
          <div className="border-b-2 border-primary-dark pb-2 mb-6">
            <h2 className="text-2xl font-bold text-primary-dark">Site Management</h2>
          </div>
          <div className="grid grid-cols-2 gap-8 mb-8">
            <div className='border-2 border-gray-lighter flex'>
              <div className='basis-1/2 w-[240px] h-[100%] overflow-hidden pr-8'>
                <div className='w-full h-full'
                  style={{
                    backgroundImage: `url("${IMAGE_MAN_WORKING}")`,
                    backgroundSize: '170% 145%',
                    backgroundPosition: '-4rem -1rem',
                    backgroundRepeat: 'no-repeat'
                  }} />
              </div>
              <div className='flex-1 py-6 px-4 -ml-8'>
                <div className="font-bold text-2xl mb-4">Manage User Access</div>
                <div className='mb-4'>Review and approve or deny pending requests for new users</div>
                <div><Button onClick={() => navigate(ENTITY_APPROVAL_URL)}>Manage Users</Button></div>
              </div>
            </div>
            <div className='border-2 border-gray-lighter flex'>
              <div className='basis-1/2 w-[240px] h-[100%] overflow-hidden pr-8'>
                <div className='w-full h-full'
                  style={{
                    backgroundImage: `url("${IMAGE_CREATE_ORGANIZATION}")`,
                    backgroundSize: '140% 115%',
                    backgroundPosition: '-4rem -1rem',
                    backgroundRepeat: 'no-repeat'
                  }} />
              </div>
              <div className='flex-1 py-6 px-4 -ml-8'>
                <div className="font-bold text-2xl mb-4">Add a New Organization</div>
                <div className='mb-4'>Create a new Vendor or Agency organization in the repository</div>
                <div><Button onClick={() => navigate(ORGANIZATION_CREATE_URL)}>Create Organization</Button></div>
              </div>
            </div>
          </div>
        </>
      )}
      {(isVendorUser || isAgencyUser) && (
        <>
          <div className="border-b-2 border-primary-dark pb-2 mb-6">
            <h2 className="text-2xl font-bold text-primary-dark">Organization Management</h2>
          </div>
          <div className="grid grid-cols-2 gap-8">
            {(isVendorUser || isAgencyUser) ? (
              <>
                <div className='border-2 border-gray-lighter flex'>
                  <div className='basis-1/2 w-[240px] h-[100%] overflow-hidden pr-8'>
                    <div className='w-full h-full'
                      style={{
                        backgroundImage: `url("${IMAGE_STICKY_NOTES}")`,
                        backgroundSize: '140% 115%',
                        backgroundPosition: '-4rem -1rem',
                        backgroundRepeat: 'no-repeat'
                      }} />
                  </div>
                  <div className='flex-1 py-6 px-4 -ml-8'>
                    <div className="font-bold text-2xl mb-4">Add A New Product</div>
                    <div className='mb-4'>Enter information for a new product link for {userEntity?.entity?.name}</div>
                    <div><Button onClick={() => navigate(PRODUCT_SUBMIT_URL)}>Add Product</Button></div>
                  </div>
                </div>
                <div className='border-2 border-gray-lighter flex'>
                  <div className='basis-1/2 w-[240px] h-[100%] overflow-hidden pr-8'>
                    <div className='w-full h-full'
                      style={{
                        backgroundImage: `url("${IMAGE_TALL_BUILDINGS}")`,
                        backgroundSize: '130% 115%',
                        backgroundPosition: '-4rem -1rem',
                        backgroundRepeat: 'no-repeat'
                      }} />
                  </div>
                  <div className='flex-1 py-6 px-4 -ml-8'>
                    <div className="font-bold text-2xl mb-4">{userEntity?.entity?.name} Overview</div>
                    <div><p className='leading-normal'>View and edit information on your organization&apos;s overview page</p></div>
                    <div><Button onClick={() => navigate(VENDOR_OVERVIEW_URL)}>View Overview Page</Button></div>
                  </div>
                </div>
              </>
            ) : null}
            {!isSuperUser && checkEntityAccessLevel([ACCESS_LEVEL_ADMIN]) ? (
              <div className='border-2 border-gray-lighter flex'>
                <div className='basis-1/2 w-[240px] h-[100%] overflow-hidden pr-8'>
                  <div className='w-full h-full'
                    style={{
                      backgroundImage: `url("${IMAGE_TAKING_NOTES}")`,
                      backgroundSize: '150% 120%',
                      backgroundPosition: '-4rem -1rem',
                      backgroundRepeat: 'no-repeat'
                    }} />
                </div>
                <div className='flex-1 py-6 px-4 -ml-8'>
                  <div className="font-bold text-2xl mb-4">ACR Editor</div>
                  <div className='mb-4'>Use the ACR Editor to create and download machine-readable Accessibility Conformance Reports (ACRs).</div>
                  <div><Button onClick={() => navigate(ACR_EDITOR_BASE_URL)}>Create an ACR</Button></div>
                </div>
              </div>
            ) : null}
            {!isSuperUser && !isImpersonating && checkEntityAccessLevel([ACCESS_LEVEL_ADMIN]) ? (
              <div className='border-2 border-gray-lighter flex'>
                <div className='basis-1/2 w-[240px] h-[100%] overflow-hidden pr-8'>
                  <div className='w-full h-full'
                    style={{
                      backgroundImage: `url("${IMAGE_MAN_WORKING}")`,
                      backgroundSize: '170% 145%',
                      backgroundPosition: '-4rem -1rem',
                      backgroundRepeat: 'no-repeat'
                    }} />
                </div>
                <div className='flex-1 py-6 px-4 -ml-8'>
                  <div className="font-bold text-2xl mb-4">Manage User Access</div>
                  <div className='mb-4'>Review and approve or deny pending requests for new users</div>
                  <div><Button onClick={() => navigate(ENTITY_APPROVAL_URL)}>Manage Users</Button></div>
                </div>
              </div>
            ) : null}
          </div>
        </>
      )}
    </>
    )
}
